// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"A-YeDVosZb1Q2yp306-g9w==","title":"xx7QpUtXIEYPHBpGuZ1W9g==","certification":"UvT7uWJ266vP9VXcwJHsiQ=="};